export default () => (
{
    navIsOpen: false,
    isMobile: false,
    width: 0,
    // Toggle the two below if you need to keep a menu open for stylng or troubleshooting, enter the name of the top-level menu item you want to keep open.
    // submenuIsOpen: 'Dental Services',
    submenuIsOpen: false,
    
    init() {
        // Set screen width on load
        this.width = window.innerWidth;
        this.setIsMobile();
    },

    setIsMobile() {
        this.isMobile = this.width < 1280;
    },

    isAfterHours() {
        // 0 - 6 is Sunday - Saturday
        // Hours are 0 - 23

        var date = new Date();
        var day = date.getDay();
        var hour = date.getHours();

        // Monday - Thursday: 8am - 4pm
        if ((day <= 4 && day >= 1) && (hour >= 8 && hour <= 16)) {
            return false;
        }
        // Friday: 8am - 1pm 
        else if (day == 5 && (hour >= 8 && hour <= 13)) {
            return false;
        }
        // After-hours
        else {
            return true;
        }
    }
});
